

import {Component, Vue} from "vue-property-decorator"
import {IAppletBanner} from "@/apis/applet/banner/types"
import config from "@/config";
import type {ICrudOption} from "@/types/m-ui-crud"
import {IPage} from "@/apis/page";
import {plantationCreateApi, plantationDetailApi, plantationModifyApi, plantationQueryApi} from "@/apis/linye";

@Component({})
export default class linyePlantation extends Vue {
  config = config
  // 表格加载状态
  tableLoading: boolean = true;
  // 表格数据
  tableData: any[] = []
  // 表格总数
  tableTotal = 0
  // 查询参数
  queryParam: IPage = {
    page: 1,
    limit: 10
  }
  // 表单参数
  modelForm: Partial<any> = {}
  // crud配置信息
  crudOption: ICrudOption = {
    delBtn: false,
    searchBox: true,
    dialogWidth: '80%',
    labelWidth: '150px',
    column: [
      {
        label: "ID",
        type: "index",
        prop: "id",
        align: "center",
        width: 50,
        addHide: true,
        editHide: true
      },
      {
        label: "负责人",
        prop: "liaison",
        placeholder: "负责人",
        search: true,
        hide: true,
        addHide: true,
        editHide: true
      },
      {
        label: "种植园名称",
        prop: "name",
        align: "center",
        width: '150px',
        placeholder: "请输入种植园名称",
        type: "text",
        rules: [
          {required: true, message: "种植园名称不能为空", trigger: "blur"}
        ],
      },
      {
        label: "负责人",
        prop: "liaison",
        align: "center",
        span: 12,
        placeholder: "请输入负责人",
        type: "text",
        rules: [
          {required: true, message: "负责人不能为空", trigger: "blur"}
        ],
        overHidden: true
      },
      {
        label: "联系电话",
        prop: "liaisonPhone",
        align: "center",
        type: "number",
        maxlength: 11,
        width: '130px',
        span: 12,
        rules: [
          {required: true, message: "联系电话不能为空", trigger: "blur"}
        ],
        overHidden: true
      },
      {
        label: "面积（亩 / 平方米）",
        prop: "area",
        align: "center",
        type: "text",
        width: '150px',
        overHidden: true
      },
      {
        label: "土壤类型",
        prop: "soilType",
        span: 12,
        align: "center",
        type: "text",
        overHidden: true
      },
      {
        label: "灌溉类型",
        prop: "irrigateType",
        align: "center",
        span: 12,
        type: "text",
        overHidden: true
      },
      {
        label: "地址",
        prop: "address",
        align: "center",
        width: '250px',
        type: "text",
      },
      {
        label: "地图选择",
        prop: "map",
        align: "center",
        width: '250px',
        type: "text",
        addSlot: true,
        editSlot: true,
        hide: true,
      },
      {
        label: "备注",
        prop: "remarks",
        align: "center",
        maxlength: 200,
        width: '250px',
        type: "textarea",
      },
      {
        label: "创建时间",
        prop: "addTime",
        align: "center",
        width: '150px',
        addHide: true,
        editHide: true,
      },

    ]
  }

  getList() {
    this.tableLoading = true
    plantationQueryApi(this.queryParam).then(e => {
      this.tableData = e.list
      this.tableTotal = e.total
      this.tableLoading = false
    })
  }

  mapInput(e: any) {
    this.modelForm.address = e.address + e.addressName
    this.modelForm.longitude = e.longitude
    this.modelForm.latitude = e.latitude
  }

  rowSave(form: IAppletBanner, done: Function, loading: Function) {
    plantationCreateApi(form).then(e => {
      if (e) {
        this.getList()
        this.$message.success("操作成功!")
        done()
      }
    }).finally(() => {
      loading()
    })
  }

  rowEdit(form: IAppletBanner, done: Function, loading: Function) {
    plantationModifyApi(form).then(e => {
      if (e) {
        this.getList()
        this.$message.success("操作成功!")
        done()
      }
    }).finally(() => {
      loading()
    })
  }

  openEdit(row: any, index: number) {
    plantationDetailApi(row.id).then(e => {
      // @ts-ignore
      this.$refs.crudRef.rowEdit(e, index)
    })
  }

  created() {
    this.getList()
  }
}
